export default __webpack_public_path__ + "static/media/3.6cd8867d.webp";